import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { MaxLength } from "../../../../utils/constants/CharactersLength";
import { ValidationMessage } from "../../../../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../../../../helper/helper";
import ODatePicker from "../../../../components/shared/datePicker/ODatePicker";
import PhoneInputField from "../../../../components/shared/FormFields/PhoneInputField";
import { regex } from "../../../../utils/constants/regexVariables";
import { constantTypes } from "../../../../utils/constants/constant";
// import ODatePicker from "../shared/datePicker/ODatePicker";
// import PhoneInputField from "../shared/FormFields/PhoneInputField";
// import { ValidationMessage } from "../../utils/constants/validationMessage";
// import { regex } from "../../utils/constants/regexVariables";
// import { whiteSpaceCheck } from "../../helper/helper";
// import { MaxLength } from "../../utils/constants/CharactersLength";
// import { ErrorMessage } from "@hookform/error-message";
// import { constantTypes } from "../../utils/constants/constant";

const FamilyInformation = ({
  familyMemberDOBError,
  handleChangeFamilyMemberDate,
  errors,
  register,
  familyMemberDOB,
  FamilyPhone,
  setFamilyPhone,
  setValue,
  fields,
  append,
  remove,
}) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Family Information</span>
      {fields.map((item, index) => (
        <div key={index} className={`border p-3 ${index !== 0 && "mt-3"}`}>
          {index !== 0 && (
            <Button
              className="bg-transparent border-0 p-0 ms-auto d-block mt-3"
              type="button"
              onClick={() => remove(index)}
            >
              <i className="bi bi-dash-circle-fill text-red fs-2"></i>
            </Button>
          )}
          <Row className="mb-3 gx-sm-3 gx-2">
            <Col xl={4} md={4} xs={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formSurname${index}`}>
                <Form.Label>
                  First Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First name"
                  name="firstName"
                  {...register(`familyInformation[${index}].firstName`, {
                    required: ValidationMessage.FIRST_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  maxLength={MaxLength.nameLen}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].firstName`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col xl={4} md={4} xs={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formGivenName${index}`}>
                <Form.Label>
                  Last Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Last name"
                  name="lastName"
                  {...register(`familyInformation[${index}].lastName`, {
                    required: ValidationMessage?.LAST_NAME_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                  maxLength={MaxLength.nameLen}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].lastName`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>

            <Col xl={4} md={4} sm={6} className="mb-3">
              <Form.Group
                className=""
                key={item.id}
                controlId={`formDesignation${index}`}
              >
                <Form.Label>Relation With</Form.Label>
                <Form.Select
                  name="relationWith"
                  {...register(`familyInformation[${index}].relationWith`, {
                    required: ValidationMessage?.RELATION_WITH_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                >
                  <option value="">Select relation with</option>
                  <option value="wife">Wife</option>
                  <option value="husband">Husband</option>
                  <option value="father">Father</option>
                  <option value="mother">Mother</option>
                  <option value="son">Son</option>
                  <option value="daughter">Daughter</option>
                  <option value="brother">Brother</option>
                  <option value="sister">Sister</option>
                  <option value="grandParent">Grand Mother</option>
                  <option value="grandFather">Grand Father</option>
                  <option value="daughterInLaw">Daughter IN-LAW</option>
                  <option value="fatherInLaw">Father IN-LAW</option>
                </Form.Select>

                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].relationWith`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>

            <Col xl={4} md={4} sm={6} className="mb-3">
              <Form.Group key={item.id} controlId={`formDepartment${index}`}>
                <Form.Label>
                  Occupation <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter occupation"
                  name="occupation"
                  {...register(`familyInformation[${index}].occupation`, {
                    required: ValidationMessage.OCCUPATION_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name={`familyInformation[${index}].occupation`}
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      ))}

      <Button
        className="bg-transparent border-0 p-0 ms-auto d-block mt-3"
        type="button"
        onClick={() => append(constantTypes.familyInformation)}
      >
        <i className="bi bi-plus-circle-fill text-orange fs-2"></i>
      </Button>
    </div>
  );
};

export default FamilyInformation;
